const fieldLabels = {
    customer_id: 'Khách hàng',
    payment_at: 'Thời gian thu',
    payment_method: 'Hình thức thu',
    branch_id: 'Cơ sở thu tiền',
    payment_breakdowns: 'Chi tiết hình thức thu',
    note: 'Ghi chú',
    total_amount: 'Tổng tiền dịch vụ',
    special_discount: 'Ưu đãi',
    amount_paid: 'Tiền khách thực nộp',
    product_amount: 'Thanh toán sản phẩm',
    service_amount_paid: 'Tiền dành cho dịch vụ',
    allocated_amount: 'Đã phân bổ',
    unallocated_amount: 'Số dư chưa phân bổ',
    remaining_debt: 'Công nợ còn lại',
    status: 'Trạng thái',
    services: 'Dịch vụ',
    provider_name: 'Nhà cung cấp',
    amount: 'Số tiền',
    quantity: 'Số lượng',
    price: 'Đơn giá',
};

const moneyFields = new Set([
    'total_amount', 'special_discount', 'amount_paid', 'product_amount', 'service_amount_paid',
    'allocated_amount', 'unallocated_amount', 'remaining_debt', 'amount', 'price',
]);
const paymentMethodLabels = {
    tienmat: 'Tiền mặt',
    chuyenkhoan: 'Chuyển khoản',
    thanhtoanthe: 'Thanh toán thẻ',
    khac: 'Khác',
    legacy_unclassified: 'Chưa phân loại',
};

const emptyValue = value => value === null || value === undefined || value === '';
const isObject = value => value && typeof value === 'object' && !Array.isArray(value);
const formatMoney = value => {
    const amount = Number(value);
    return `${Number.isFinite(amount) ? amount.toLocaleString('en-US', { maximumFractionDigits: 2 }) : 0}đ`;
};
const humanizeKey = key => fieldLabels[key]
    || String(key || '').replace(/_/g, ' ').replace(/^./, value => value.toUpperCase());

const parseLegacyJson = value => {
    if (typeof value !== 'string') return value;
    const trimmed = value.trim();
    if (!trimmed || !['{', '['].includes(trimmed.charAt(0))) return value;
    try {
        return JSON.parse(trimmed);
    } catch (error) {
        return value;
    }
};

const formatFieldValue = (key, value, depth) => {
    if (key === 'payment_method' && paymentMethodLabels[value]) return paymentMethodLabels[value];
    return formatHistoryValue(value, moneyFields.has(key) ? 'money' : 'text', depth + 1);
};

const formatObject = (value, depth) => {
    const descriptiveKeys = ['label', 'name', 'title', 'description', 'reason', 'summary', 'text', 'code'];
    const descriptiveKey = descriptiveKeys.find(key => !emptyValue(value[key]) && typeof value[key] !== 'object');
    const descriptor = descriptiveKey ? formatHistoryValue(value[descriptiveKey], 'text', depth + 1) : '';
    const detailKeys = Object.keys(value).filter(key => !descriptiveKeys.includes(key)
        && !['id', 'key', 'created_at', 'updated_at', 'deleted_at'].includes(key)
        && !emptyValue(value[key]));

    if (descriptor && !detailKeys.length) return descriptor;
    const details = detailKeys.map(key => `${humanizeKey(key)}: ${formatFieldValue(key, value[key], depth)}`);
    return [descriptor, ...details].filter(Boolean).join(' · ') || '—';
};

export const formatHistoryValue = (rawValue, type = 'text', depth = 0) => {
    const value = parseLegacyJson(rawValue);
    if (emptyValue(value)) return '—';
    if (depth > 6) return 'Dữ liệu chi tiết';
    if (type === 'money' && !Array.isArray(value) && !isObject(value)) return formatMoney(value);
    if (typeof value === 'boolean') return value ? 'Có' : 'Không';
    if (Array.isArray(value)) {
        if (!value.length) return '—';
        return value.map(item => formatHistoryValue(item, 'text', depth + 1)).join(depth > 0 ? ', ' : ' • ');
    }
    if (isObject(value)) return formatObject(value, depth);

    const text = String(value).replace(/<br\s*\/?>/gi, '\n').trim();
    if (/^\[object\s+(Object|Array)\]$/i.test(text) || text === 'undefined') return 'Dữ liệu lịch sử';
    return text || '—';
};

/** Mutation lưu snapshot before/after nhưng dòng có nhãn “Lý do” phải ưu tiên reason nghiệp vụ. */
export const prepareHistoryChange = change => {
    if (change?.field === 'financial_mutation' && !emptyValue(change.note)) {
        return { ...change, old: null, new: change.note, note: null, singleValue: true };
    }
    return { ...(change || {}), singleValue: false };
};

